import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/DepositPortal", { replace: true });
    }, 1);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>

    </>
  );
};

export default PageNotFound;
